import React, { useState } from "react";
import Layout from "../pages/Layout";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigate = useNavigate();
  return (
    <Layout>
    
    </Layout>
  );
};

export default Settings;
